import { Helmet } from "react-helmet";
import ServedClientsBody from "../components/served-clients/ServedClientsBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function Served() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.ntuna.com/solutions/clients" />
        <meta
          name="description"
          content="See NTUNA.COM's clients around the world that have had a satisfactory taste and test of our works in Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking for their brands and organizations."
        />
        
        <meta
          property="og:description"
          content="See NTUNA.COM's clients around the world that have had a satisfactory taste and test of our works in Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking for their brands and organizations."
        />
        <meta property="og:title" content="NTUNA.COM | Clients" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta name="twitter:title" content="NTUNA.COM | Clients" />
        <meta name="twitter:text:title" content="NTUNA.COM | Clients" />
        <meta
          name="twitter:description"
          content="See NTUNA.COM's clients around the world that have had a satisfactory taste and test of our works in Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking for their brands and organizations."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM | Clients</title>
      </Helmet>
      <PageHero
        classes="dark-bg"
        titleClasses="title uppercase ntuna-deep-blue"
        title="Clients"
      />
      <ServedClientsBody />
    </>
  );
}
